import { render } from "./tab-menu-client.vue?vue&type=template&id=b187c6a0"
import script from "./tab-menu-client.vue?vue&type=script&lang=js"
export * from "./tab-menu-client.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__